<template>
    <div class="container-md ">
        <div class=" container-bg p-5 ">
            <div class="row">
                <div class="col-12">
                    <h3 class="text-uppercase">My RESPONSIBILITIES</h3>

                </div>


            </div>
            <div class="row">
                <div class="col-12">
                    <i class="fa fa-plus float-right ml-2" data-toggle="modal" data-target="#newTask"
                       style="font-size: 24px;cursor: pointer" v-on:click="newResponsibility"></i>

                    <div class="float-right ">
                        <input class="search-box" type="text" placeholder="Zoeken">
                        <button class="search-btn"><img
                                src="/assets/img/search.svg" alt="Search"
                                style="margin-bottom: 3px"></button>
                    </div>
                </div>
            </div>

            <div class="row pt-4">
                <div class="col-12">
                    <div class="nav nav-tabs nav-fill" id="nav-tab" role="tablist" style="display: unset">
                        <a class="btn text-white btn-dark active item  mr-3 anchor"
                           id="nav-next-event"
                           data-toggle="tab" aria-controls="next-event" href="#all-event" role="tab"
                           aria-selected="true">All</a>
                        <a class="btn text-white btn-dark item  mr-4 anchor"
                           data-toggle="tab"
                           href="#individual-event" role="tab" aria-selected="false">Individual</a>
                        <a class="btn text-white btn-dark item  mr-4 anchor"
                           data-toggle="tab"
                           href="#group-event" role="tab" aria-selected="false">Group</a>
                        <a class="btn text-white btn-dark item  mr-4 anchor"
                           data-toggle="tab"
                           href="#calender-event" role="tab" aria-selected="false">Transfered</a>
                        <a class="btn text-white btn-dark item  mr-4 anchor"
                           data-toggle="tab"
                           href="#calender-event" role="tab" aria-selected="false">Archived</a>

                    </div>
                </div>
            </div>

            <!-- all events start-->
            <div class="tab-content " id="nav-tabContent">
                <!--                    all event-->
                <div id="all-event" class="tab-pane fade show active" role="tabpanel"
                     style="background-color: unset !important;">
                    <div class="flex-container flex-body mt-3">

                        <div class="item text-white" style="flex: 7;margin-left: 30px;">Responsibility title ipsum</div>
                        <div class="item" style="flex: 1 1 2%;">
                            <img src="./../../../assets/images/adult-1851571_1920.png"
                                 style="height: 35px;width: 35px;margin-left: -8px;margin-top:-8px;border:1px solid #FFFFFF;border-radius: 50%"
                                 alt="">
                            <img src="./../../../assets/images/guitar-869217_1920.png"
                                 style="height: 35px;width: 35px;margin-left: -8px;margin-top:-8px;border:1px solid #FFFFFF;border-radius: 50%"
                                 alt="">
                            <img src="./../../../assets/images/adult-1851571_1920.png"
                                 style="height: 35px;width: 35px;margin-left: -8px;margin-top:-8px;border:1px solid #FFFFFF;border-radius: 50%"
                                 alt="">
                            <img src="./../../../assets/images/adult-1851571_1920.png"
                                 style="height: 35px;width: 35px;margin-left: -8px;margin-top:-8px;border:1px solid #FFFFFF;border-radius: 50%"
                                 alt="">
                        </div>
                        <div class="item" style="flex: 0.1;">
                            <button class="btn btn-dark">Transfer</button>
                        </div>
                        <div class="item text-lg-center" style="flex: 2.1;">
                            <button class="btn btn-dark">Archive</button>
                        </div>

                        <div class="item" style="flex: 0.1;">
                            <!--                                <i class="fa fa-caret-right"></i>-->
                            <span class="panel-heading collapsed ml-3" data-toggle="collapse" data-target="#demo"
                                  style="cursor: pointer"> <i class="chevron fa"></i></span>
                        </div>

                    </div>
                    <div id="demo" class="collapse">


                        <div class="container bg-white  mt-2" style="width: 93%;margin-left: 28px;">
                            <div class="row" style="padding:30px;">
                                <div class="col-12 "><i class="fas fa-pencil-alt float-right" data-toggle="modal" data-target="#newTask" aria-hidden="true" style="cursor:pointer;" v-on:click="editResponsibility"></i>
                                </div>
                                <div class="col-12 ">
                                    <div><p style=" font-size: 14px;"><b>Created by:</b> Sed ut Member name/Committee
                                        name</p>
                                    </div>
                                    <div>
                                        <p style=" font-size: 14px;"><b>Creation date:</b> May 1st 2020</p>
                                    </div>
                                    <div>
                                        <p style=" font-size: 14px;"><b>Description:</b> Lorem ipsum dolor sit amet,
                                            consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et
                                            dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation
                                            ullamco laboris nisi ut aliquip ex ea commodo consequat.</p>
                                    </div>

                                    <div>
                                        <p style=" font-size: 14px;"><b>Attached files:</b></p>
                                    </div>
                                    <div>
                                        <div class="row">
                                            <div class="col-1">
                                                <img src="/assets/img/attach_blue.svg"
                                                     alt="" style="margin-left: 31px;">
                                            </div>
                                            <div class="col-4">
                                                <p style="font-size: 14px;  color: #4192D9; margin-left: -10px;">
                                                    document.pdf</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div>
                                        <b style=" font-size: 14px;">Transfered history:</b>
                                    </div>
                                    <div>
                                        <p style=" font-size: 14px;"> - 5th May 2020 - From Muzikanten to Lorem
                                            ipsum.</p>
                                    </div>
                                    <div>
                                        <p style=" font-size: 14px; margin-left: 20px;"> Added comments: Dolor sit amet,
                                            consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et
                                            dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation
                                            ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure
                                            dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla
                                            pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui
                                            officia deserunt mollit anim id est laborum.</p>
                                    </div>
                                    <div>
                                        <p style=" font-size: 14px; margin-left: 20px;">Attached files:</p>
                                    </div>
                                    <div style="margin-left: 20px;">
                                        <div class="row">
                                            <div class="col-1">
                                                <img src="/assets/img/attach_blue.svg"
                                                     alt="" style="margin-left: 31px;">
                                            </div>
                                            <div class="col-4">
                                                <p style=" font-size: 14px;  color: #4192D9; margin-left: -10px;">
                                                    lorem_ipsum_document.pdf</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div>
                                        <p style=" font-size: 14px;">- 10th May 2020 - From Lorem ipsum to Dolor
                                            set.</p>
                                    </div>

                                    <div>
                                        <p style=" font-size: 14px;">Added comments: Dolor sit amet, consectetur
                                            adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna
                                            aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris
                                            nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in
                                            reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla
                                            pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui
                                            officia deserunt mollit anim id est laborum.</p>
                                    </div>
                                </div>


                            </div>

                        </div>

                    </div>
                </div>
                <!--                    individual event-->
                <div id="individual-event" class="tab-pane " role="tabpanel"
                     style="background-color: unset !important;">
                    <div class="flex-container flex-body mt-3">

                        <div class="item text-white" style="flex: 7;margin-left: 30px;">Responsibility title ipsum</div>
                        <div class="item" style="flex: 1 1 2%;">
                            <img src="./../../../assets/images/adult-1851571_1920.png"
                                 style="height: 35px;width: 35px;margin-left: -8px;margin-top:-8px;border:1px solid #FFFFFF;border-radius: 50%"
                                 alt="">
                            <img src="./../../../assets/images/guitar-869217_1920.png"
                                 style="height: 35px;width: 35px;margin-left: -8px;margin-top:-8px;border:1px solid #FFFFFF;border-radius: 50%"
                                 alt="">
                            <img src="./../../../assets/images/adult-1851571_1920.png"
                                 style="height: 35px;width: 35px;margin-left: -8px;margin-top:-8px;border:1px solid #FFFFFF;border-radius: 50%"
                                 alt="">
                            <img src="./../../../assets/images/adult-1851571_1920.png"
                                 style="height: 35px;width: 35px;margin-left: -8px;margin-top:-8px;border:1px solid #FFFFFF;border-radius: 50%"
                                 alt="">
                        </div>
                        <div class="item" style="flex: 0.1;">
                            <button class="btn btn-dark">Transfer</button>
                        </div>
                        <div class="item text-lg-center" style="flex: 2.1;">
                            <button class="btn btn-dark">Archive</button>
                        </div>

                        <div class="item" style="flex: 0.1;">
                            <!--                                <i class="fa fa-caret-right"></i>-->
                            <span class="panel-heading collapsed ml-3" data-toggle="collapse" data-target="#"
                                  style="cursor: pointer"> <i class="chevron fa"></i></span>
                        </div>

                    </div>
                </div>


                <!--group event-->
                <div id="group-event" class="tab-pane" role="tabpanel"
                     style="background-color: unset !important;">
                    <div class="flex-container flex-body mt-3">

                        <div class="item text-white" style="flex: 7;margin-left: 30px;">Responsibility title ipsum</div>
                        <div class="item" style="flex: 1 1 2%;">
                            <img src="./../../../assets/images/adult-1851571_1920.png"
                                 style="height: 35px;width: 35px;margin-left: -8px;margin-top:-8px;border:1px solid #FFFFFF;border-radius: 50%"
                                 alt="">
                            <img src="./../../../assets/images/guitar-869217_1920.png"
                                 style="height: 35px;width: 35px;margin-left: -8px;margin-top:-8px;border:1px solid #FFFFFF;border-radius: 50%"
                                 alt="">
                            <img src="./../../../assets/images/adult-1851571_1920.png"
                                 style="height: 35px;width: 35px;margin-left: -8px;margin-top:-8px;border:1px solid #FFFFFF;border-radius: 50%"
                                 alt="">
                            <img src="./../../../assets/images/adult-1851571_1920.png"
                                 style="height: 35px;width: 35px;margin-left: -8px;margin-top:-8px;border:1px solid #FFFFFF;border-radius: 50%"
                                 alt="">
                        </div>
                        <div class="item" style="flex: 0.1;">
                            <button class="btn btn-dark">Transfer</button>
                        </div>
                        <div class="item text-lg-center" style="flex: 2.1;">
                            <button class="btn btn-dark">Archive</button>
                        </div>

                        <div class="item" style="flex: 0.1;">
                            <!--                                <i class="fa fa-caret-right"></i>-->
                            <span class="panel-heading collapsed ml-3" data-toggle="collapse" data-target="#"
                                  style="cursor: pointer"> <i class="chevron fa"></i></span>
                        </div>

                    </div>
                </div>


            </div>


        </div>
        <responsibilityModal v-bind:isEdit="isEdit"></responsibilityModal>
    </div>

</template>

<script>
    import responsibilityModal from "./responsibilityModal";

    export default {
        name: "responsibilities",
        components: {
            responsibilityModal
        },
        data() {
            return {
                isEdit: false,
            }
        },
        methods: {
            newResponsibility() {
                this.isEdit = false;
            },
            editResponsibility() {

                this.isEdit = true;

            }
        },
    }
</script>

<style scoped>

    .search-box {
        background: #FFFFFF 0% 0% no-repeat padding-box;
        border: 1px solid #292929;
        border-radius: 4px;
        width: 20rem;
    }

    .search-btn {
        background: transparent;
        border: unset;
        margin-left: -30px;

        -webkit-appearance: none;
    }


    .active {
        background-color: #4192D9 !important;
        border: #4192D9;

    }

    .anchor {
        padding: 5px 20px !important;
    }

    .flex-container {
        display: flex;
        flex-flow: row wrap;
        position: relative;
        width: auto;
        align-items: center;

        opacity: 1;
    }

    .flex-body {
        background: #4192D9 0% 0% no-repeat padding-box;
        box-shadow: 1px 5px 10px #0000004B;
        border-radius: 20px;
    }

    .item {
        flex: 1 1 14%;
        height: auto;
        margin: 4px;
        margin-right: 10px;
        padding: 10px 0;
        width: auto;
    }

    @media (min-width: 576px) {
        .modal-dialog {
            max-width: 900px;
            margin: 1.75rem auto;
            margin-top: 9rem;
        }

        .delete-modal {
            max-width: 600px !important;
            margin: 1.75rem auto;
        }
    }

    .panel-heading .chevron:after {
        content: "\f0d7";
    }

    .panel-heading.collapsed .chevron:after {
        content: "\f0da";
    }


</style>
